import React from "react";

function Canvas_Images() {
  return (
    <div>
      <h1>Canvas_Images Component</h1>
      <p>This is the Canvas Images tutorial page content.</p>
    </div>
  );
}

export default Canvas_Images;
